'use strict';exports.__esModule = true;exports.ADDITIONAL_PROMO_THEMES = undefined;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);


var _RealtorAdditionalPromotion = require('./RealtorAdditionalPromotion.scss');var styles = _interopRequireWildcard(_RealtorAdditionalPromotion);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ADDITIONAL_PROMO_THEMES = exports.ADDITIONAL_PROMO_THEMES = {
  GREEN: 'green',
  PINK: 'pink',
  ORANGE: 'orange' }; // styles


var RealtorAdditionalPromotion = function RealtorAdditionalPromotion(props) {return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.promotionWrapper, styles[props.theme]) },
      _react2.default.createElement('div', { className: styles.title }, props.title),
      _react2.default.createElement('div', { className: styles.description }, props.description),
      _react2.default.createElement('div', { className: styles.addPromo },
        props.buttonTitle, '\xA0\u20AA\xA0', props.price)));};




RealtorAdditionalPromotion.propTypes = {
  theme: _propTypes2.default.oneOf(Object.values(ADDITIONAL_PROMO_THEMES)),
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  buttonTitle: _propTypes2.default.string,
  price: _propTypes2.default.number };exports.default =


RealtorAdditionalPromotion;


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorAdditionalPromotion/RealtorAdditionalPromotion.js
// module id = 1236
// module chunks = 0